import type { SVGProps } from 'react';

const Favorites = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="45" height="44" viewBox="0 0 45 44" fill="none" {...props}>
        <rect x="0.5" y="0.5" width="44" height="43" rx="3.5" stroke="currentColor" fill="none" />
        <path
            className="heart"
            d="M22.5 33C22.5 33 11 23.5 11 17.5C11 13.5 14 10.5 18 10.5C20.5 10.5 22 12 22.5 13C23 12 24.5 10.5 27 10.5C31 10.5 34 13.5 34 17.5C34 23.5 22.5 33 22.5 33Z"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.5"
        />
    </svg>
);

export default Favorites;
